import { Coffee, MapPin, Music, Book, Dumbbell, Gamepad2, Camera, Palette } from "lucide-react";

export const interests = [
  { id: "coffee", label: "Coffee", icon: Coffee },
  { id: "hiking", label: "Hiking", icon: MapPin },
  { id: "music", label: "Music", icon: Music },
  { id: "books", label: "Books", icon: Book },
  { id: "sports", label: "Sports", icon: Dumbbell },
  { id: "gaming", label: "Gaming", icon: Gamepad2 },
  { id: "photography", label: "Photography", icon: Camera },
  { id: "art", label: "Art", icon: Palette },
];
